import { queryKeys as queryKeysDocumentTags } from '~/composables/api/document-tags/useQueryDocumentTags'

import { useFetchDocumentTag } from './useFetchDocumentTag'
import { useQueryClientUtils } from '../../useQueryClientUtils'
import { type QueryDocumentByIdCacheData, queryKeys as queryKeysDocument } from '../useQueryDocument'

const update = () => {
  const { update } = useFetchDocumentTag()
  const queryClient = useQueryClient()
  const { cancelQueries, invalidateQueries } = useQueryClientUtils()

  return useMutation({
    mutationFn: update,
    onMutate: (variables) => {
      cancelQueries([
        queryKeysDocument.byId({
          id: variables.documentId,
          workspaceId: variables.workspaceId,
        }).queryKey,
        queryKeysDocumentTags.all._def,
      ])
    },
    onSuccess: (responseData, variables) => {
      queryClient.setQueriesData<QueryDocumentByIdCacheData>({
        queryKey: queryKeysDocument.byId({
          id: variables.documentId,
          workspaceId: variables.workspaceId,
        }).queryKey,
      }, (oldData) => {
        if (!oldData)
          return oldData

        return {
          ...oldData,
          data: {
            ...oldData.data,
            tags: responseData.data,
          },
        }
      }, {
        updatedAt: Date.now(),
      })
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeysDocumentTags.all._def,
      })
    },
    onError: (_, variables) => {
      invalidateQueries([
        queryKeysDocument.byId({
          id: variables.documentId,
          workspaceId: variables.workspaceId,
        }).queryKey,
      ])
    },
  })
}

export const useMutationDocumentTag = {
  update,
}
